import { useQuery } from '@tanstack/react-query';

import { programsApi } from '../api/programsApi';
import { Instructor } from '../types/program';

export const useInstructor = (instructorId?: number) => {
  return useQuery<Instructor>({
    queryKey: ['instructor', instructorId],
    queryFn: () => programsApi.fetchInstructor(instructorId),
    enabled: !!instructorId,
  });
};
